import { createReducer, on } from "@ngrx/store";
import { CheckedOutEntity, CheckedOutEntityType } from "src/app/models/activity-logs/signalR.model";
import { addCheckedOutEntity, removeCheckedOutEntity, setCheckedOutEntities } from "../actions/checked-out-entities.actions";

export const CheckedOutEntitiesReducer = createReducer<Record<CheckedOutEntityType, CheckedOutEntity[]>>(
    {
        Automate365Approval: [],
        Automate365Automation: [],
        Automate365Policy: [],
        Automate365Template: []
    },

    on(setCheckedOutEntities,
        (state, { value }) => ({ ...value })
    ),

    on(addCheckedOutEntity,
        (state, { entityType, entity }) => ({ ...state, [entityType]: [...(state[entityType] || []), entity] })
    ),

    on(removeCheckedOutEntity,
        (state, { entityType, entityId }) => ({ ...state, [entityType]: state[entityType].filter(x => x.id !== entityId) })
    ),
)
